module.exports = __webpack_public_path__ + "img/HUC.810fb1d2.svg";